<template>
  <div>
    <v-app-bar dense :clipped-left="$vuetify.breakpoint.smAndUp" flat app>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click.stop="toggleMenu()">
            <img height="15" width="15" src="../../../assets/icons/menu.svg" />
          </v-btn>
        </template>
        <span>Menú</span>
      </v-tooltip>

      <img
        src="../../../assets/images/paradise_logo.svg"
        height="25"
        class="ml-4"
        alt="Paradise Logo"
      />

      <v-spacer />

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" class="d-md-none">
            <v-icon>search</v-icon>
          </v-btn>
        </template>
        <span>Cerca</span>
      </v-tooltip>

      <TopBarCalendar />

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click.stop="logout">
            <v-icon>power_settings_new</v-icon>
          </v-btn>
        </template>
        <span>Desconnectar</span>
      </v-tooltip>
    </v-app-bar>
  </div>
</template>

<script>
import TopBarCalendar from "@/layouts/intranet/components/TopBarCalendar.vue"

export default {
  components: {
    TopBarCalendar,
  },
  props: {
    navDrawer: Boolean,
  },
  data: () => ({}),
  methods: {
    toggleMenu() {
      this.$emit("toggleMenu", !this.navDrawer)
    },
    logout() {
      this.$store.dispatch("logout")
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped></style>
